const SESSION_KEY = 'keywordyab_session_key';
const TAB_ID_KEY = 'keywordyab_tab_id';

function randomId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `sess-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function getClientSessionKey(): string {
  try {
    let key = localStorage.getItem(SESSION_KEY);
    if (!key) {
      key = randomId();
      localStorage.setItem(SESSION_KEY, key);
    }
    return key;
  } catch {
    return randomId();
  }
}

export function getClientInstanceKey(): string {
  try {
    let tabId = sessionStorage.getItem(TAB_ID_KEY);
    if (!tabId) {
      tabId = randomId();
      sessionStorage.setItem(TAB_ID_KEY, tabId);
    }
    return `${getClientSessionKey()}:${tabId}`;
  } catch {
    return randomId();
  }
}
